import Country from "@bimproject/country";

import * as UI from "../../../modules/ui-kit";

// One pricelist targets a single country. Backend still stores countries[]
// (multi kept for future), so this component reads/writes a one-element array
// while presenting a single mandatory select (no "all regions" option).
const OPTIONS: { label: string; value: string }[] = [
    { label: "Select a country…", value: "" },
    ...Country.all()
        .map((code) => ({ label: Country.fromCode(code).name, value: code }))
        .sort((a, b) => a.label.localeCompare(b.label)),
];

export default function CountrySelect({
    value,
    onChange,
    disabled,
}: {
    value: string[];
    onChange: (value: string[]) => void;
    disabled?: boolean;
}) {
    return (
        <UI.Select
            value={value[0] ?? ""}
            onSelect={(v) => onChange(v ? [v] : [])}
            options={OPTIONS}
            isDisabled={disabled}
        />
    );
}
